module.exports = __webpack_public_path__ + "img/marker-point-naranja.200ae205.png";